const pl = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH, ambulatoryjna służba opieki we Frankfurcie nad Menem. Troskliwa, fachowa opieka w domu: pielęgnacja podstawowa, opieka medyczna, pomoc w gospodarstwie domowym i całodobowa dostępność.",
    pages: {
      home: "",
      about: "O nas",
      services: "Usługi",
      news: "Aktualności i oferty pracy",
      contact: "Kontakt",
      imprint: "Impressum",
      privacy: "Polityka prywatności",
      notFound: "Nie znaleziono strony",
    },
  },

  common: {
    call: "Zadzwoń",
    callNow: "Zadzwoń teraz:",
    contactUs: "Skontaktuj się z nami",
    bookConsultation: "Umów konsultację",
    bookAppointment: "Umów spotkanie",
    requestConsultation: "Poproś o konsultację",
    aroundTheClock: "Całą dobę:",
    reachable24h: "Dostępni całą dobę",
    certifiedStaff: "Dyplomowany personel",
    whatsapp: "WhatsApp",
    whatsappText: "Dzień dobry, mam pytanie dotyczące Państwa usług opiekuńczych.",
    whatsappNote: "Prosimy nie przesyłać danych o zdrowiu przez WhatsApp. W nagłych przypadkach prosimy o telefon.",
    symbolImage: "Zdjęcie poglądowe",
    language: "Język",
    changeLanguage: "Wybierz język",
    skipToContent: "Przejdź do treści",
    legalNote: "To tłumaczenie ma charakter informacyjny. Prawnie wiążąca jest wersja niemiecka.",
  },

  header: {
    topbar24h: "Dostępni 24 h",
    topbarConsult: "Bezpłatna, osobista konsultacja",
    mainNav: "Nawigacja główna",
    mobileNav: "Nawigacja mobilna",
    openMenu: "Otwórz menu",
    closeMenu: "Zamknij menu",
  },

  nav: {
    home: "Start",
    about: "O nas",
    services: "Usługi",
    news: "Aktualności",
    contact: "Kontakt",
    jobs: "Oferty pracy",
    imprint: "Impressum",
    privacy: "Prywatność",
  },

  footer: {
    reach: "Jak nas zastać",
    fax: "Faks:",
    emergency: "Całodobowy numer alarmowy:",
    navigation: "Nawigacja",
    legal: "Informacje prawne",
    area: "Frankfurt nad Menem i okolice (przede wszystkim Nieder-Eschbach)",
    rights: "Wszelkie prawa zastrzeżone.",
  },

  floating: {
    whatsappLabel: "Napisz do nas na WhatsAppie",
    callLabel: "Zadzwoń teraz:",
    toTop: "Przewiń do góry",
  },

  home: {
    eyebrow: "Ambulatoryjna służba opieki · Frankfurt nad Menem",
    h1a: "Troskliwa, fachowa",
    h1b: "opieka w domu",
    lead:
      "Dla życia bez trosk, także gdy wiek lub choroba wymagają opieki. Mamy dla Państwa czas.",
    heroImgAlt: "Opiekunka z Nieder-Eschbacher Pflegedienst kładzie dłonie na ramionach uśmiechniętego starszego pana; obok logo i usługi: opieka podstawowa, opieka medyczna, pomoc w domu, indywidualne wsparcie",
    badgeTitle: "Z sercem i czasem",
    badgeText: "Opieka bez pośpiechu",
    welcomeQuote:
      "My, zespół Nieder-Eschbacher Pflegedienst we Frankfurcie nad Menem, cieszymy się z Państwa zainteresowania. Dzień po dniu pracujemy dla osób, które obdarzają nas zaufaniem, i zapewniamy opiekę wysokiej jakości w zaciszu Państwa domu. Nasi życzliwi opiekunowie mają dla Państwa czas.",
    features: [
      {
        icon: "Clock",
        title: "Mamy czas",
        text: "Troskliwe podejście bez pośpiechu. Chcemy, aby czuli się Państwo u nas dobrze.",
        to: "about",
        cta: "O nas",
      },
      {
        icon: "HeartHandshake",
        title: "Nasze usługi",
        text: "Pielęgnacja podstawowa i opieka medyczna, dopasowane indywidualnie do Państwa.",
        to: "services",
        cta: "Usługi",
      },
      {
        icon: "Newspaper",
        title: "Aktualności i oferty pracy",
        text: "Nowości z naszej służby opieki i wolne stanowiska w opiece.",
        to: "news",
        cta: "Aktualności",
      },
    ],
    servicesEyebrow: "Nasze usługi",
    servicesTitle: "Indywidualna opieka, dokładnie według Państwa potrzeb",
    servicesLead:
      "Od pielęgnacji podstawowej po całodobową dostępność: wspieramy Państwa kompleksowo we własnym domu.",
    valuesEyebrow: "Nasze wartości",
    valuesTitle: "Szacunek, troska i odpowiedzialne podejście",
    valuesLead:
      "Szacunek, troska i odpowiedzialne podejście to nasze najważniejsze zasady. Każdego człowieka traktujemy tak, jak sami chcielibyśmy być traktowani.",
    ctaTitle: "Nie wiedzą Państwo, jaki stopień opieki Państwu przysługuje?",
    ctaLead: "Chętnie doradzimy osobiście, u nas lub u Państwa w domu. Bezpłatnie i bez zobowiązań.",
  },

  values: [
    { icon: "Heart", label: "Indywidualna opieka" },
    { icon: "BadgeCheck", label: "Dyplomowany personel" },
    { icon: "MessageCircle", label: "Osobiste doradztwo" },
    { icon: "ShieldCheck", label: "Odpowiedzialne podejście" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "Pielęgnacja podstawowa",
      short: "Higiena, pomoc w poruszaniu się i w codziennych czynnościach, spokojnie i z godnością.",
      description:
        "W ramach pielęgnacji podstawowej z wyczuciem wspieramy Państwa we wszystkich codziennych czynnościach związanych z higieną i poruszaniem się. Mamy czas i zawsze szanujemy Państwa godność oraz prawo do samodzielnych decyzji.",
      points: [
        "Higiena osobista (mycie, kąpiel, prysznic)",
        "Pomoc w poruszaniu się i zmiana pozycji",
        "Pielęgnacja przy nietrzymaniu moczu",
        "Pomoc przy jedzeniu i piciu",
        "Ubieranie i rozbieranie",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "Opieka medyczna",
      short: "Czynności medyczne na zlecenie lekarza, niezawodnie i fachowo.",
      description:
        "Opieka medyczna obejmuje wszystkie czynności konieczne z medycznego punktu widzenia i zawsze odbywa się na zlecenie lekarza. Nasz dyplomowany personel ściśle współpracuje z Państwa lekarzami.",
      points: [
        "Podawanie i przygotowywanie leków",
        "Zastrzyki",
        "Zakładanie i zdejmowanie pończoch uciskowych",
        "Nowoczesne zaopatrywanie ran",
        "Kontrola poziomu cukru i ciśnienia",
      ],
      note: "Opieka medyczna odbywa się zawsze na zlecenie lekarza.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "Pomoc w gospodarstwie domowym",
      short: "Zajmujemy się domem, aby mogli się Państwo czuć w nim naprawdę dobrze.",
      description:
        "Zadbany dom w dużej mierze decyduje o dobrym samopoczuciu. Pomagamy w prowadzeniu gospodarstwa domowego, aby we własnych czterech ścianach czuli się Państwo spokojnie i bezpiecznie.",
      points: [
        "Zakupy i załatwianie spraw",
        "Przygotowywanie posiłków",
        "Pranie",
        "Sprzątanie mieszkania",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "Dodatkowe usługi opiekuńcze",
      short: "Wspólny czas, rozmowa i aktywizacja dla większej radości życia.",
      description:
        "Oprócz opieki pielęgnacyjnej bardzo ważna jest dla nas ludzka bliskość. Odciążamy opiekujących się bliskich i dajemy Państwu czas na miłe wspólne chwile.",
      points: [
        "Odciążenie opiekujących się bliskich",
        "Trening orientacji",
        "Rozmowa i towarzystwo",
        "Praca z biografią",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "Instruktaż dla opiekujących się bliskich",
      short: "Pomagamy Państwa bliskim pomagać Państwu.",
      description:
        "Opiekujący się bliscy wykonują ogromną pracę. Dajemy praktyczne wskazówki i pewność w opiece, indywidualnie i zrozumiale, u Państwa w domu.",
      points: [
        "Praktyczny instruktaż opieki w domu",
        "Doradztwo w zakresie środków pomocniczych",
        "Wskazówki do codzienności z opieką",
        "Pewność w sprawowaniu opieki",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "Dostępność całą dobę",
      short: "Pod numerem komórkowym jesteśmy dostępni całą dobę, aby czuli się Państwo bezpiecznie.",
      description:
        "W nagłych przypadkach jesteśmy do Państwa dyspozycji o każdej porze dnia i nocy. Pod naszym komórkowym numerem alarmowym dodzwonią się Państwo całą dobę.",
      points: [
        "Komórkowy numer alarmowy: 0177 / 7202956",
        "Alternatywnie: 0157 / 36442746",
        "Szybka pomoc w nagłej sytuacji",
        "Bezpieczeństwo dla Państwa i bliskich",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "Usługi",
    title: "Kompleksowa opieka, indywidualnie dla Państwa",
    subtitle:
      "Oferujemy szeroki zakres usług pielęgnacyjnych i pomocy w gospodarstwie domowym, dokładnie dopasowany do Państwa sytuacji.",
    shortLongTitle: "Opieka krótkoterminowa i stała",
    shortLongText:
      "Przejściowo po pobycie w szpitalu czy na stałe: elastycznie dopasowujemy opiekę do Państwa sytuacji życiowej. Dzięki temu otrzymują Państwo dokładnie takie wsparcie, jakiego teraz potrzebują.",
    adviceTitle: "Doradztwo w sprawie stopni opieki i kasy pielęgnacyjnej",
    adviceText:
      "System opieki jest skomplikowany. Zrozumiale wyjaśniamy, jakie świadczenia Państwu przysługują, i krok po kroku pomagamy w złożeniu wniosku do kasy pielęgnacyjnej.",
    ctaTitle: "Poproś o bezpłatną konsultację",
    ctaLead: "Chętnie doradzimy osobiście i bez zobowiązań, u nas lub u Państwa w domu.",
  },

  about: {
    eyebrow: "O nas",
    title: "Ludzie, którzy mają czas",
    subtitle:
      "Poznaj nasz zespół i naszą filozofię. Wyróżniają nas czas, szacunek, troska i prawdziwe człowieczeństwo.",
    introTitle: "Państwa dobre samopoczucie jest najważniejsze",
    intro: [
      "Jesteśmy zespołem Nieder-Eschbacher Pflegedienst we Frankfurcie nad Menem. Dzień po dniu pracujemy dla osób, które obdarzają nas zaufaniem. Opieka jest dla nas czymś znacznie więcej niż zadaniem. To sprawa serca.",
      "Nasz życzliwy, dyplomowany personel świadomie poświęca Państwu czas. Dobra opieka potrzebuje spokoju, uwagi i gotowości do słuchania, bez pośpiechu.",
      "Opiekujemy się Państwem tam, gdzie czują się Państwo najlepiej: we własnym domu, w znanym otoczeniu. Dzięki temu zachowują Państwo samodzielność i prywatność.",
    ],
    teamImgAlt: "Opiekunka troskliwie trzyma za ręce starszą panią na wózku inwalidzkim (zdjęcie poglądowe)",
    valuesTitle: "Wartości, które nas prowadzą",
    valuesLead: "Szacunek, troska i odpowiedzialne podejście to nasze najważniejsze zasady.",
    pillars: [
      { icon: "Clock", title: "Czas", text: "Pracujemy bez pośpiechu i poświęcamy Państwu prawdziwą uwagę." },
      { icon: "Heart", title: "Troska", text: "Każdy człowiek jest wyjątkowy. Nasza opieka również." },
      { icon: "Home", title: "Dom", text: "Opieka w znanym otoczeniu, które daje poczucie bezpieczeństwa." },
    ],
    ctaTitle: "Poznajmy się",
    ctaLead: "Cieszymy się na osobistą rozmowę z Państwem.",
  },

  newsPage: {
    eyebrow: "Aktualności",
    title: "Aktualności i oferty pracy",
    subtitle: "Nowości z naszej służby opieki i wolne stanowiska dla wszystkich, którzy chcą dołączyć do naszego zespołu.",
    newsTitle: "Aktualności",
    newsLead: "Bieżące informacje z naszej służby opieki.",
    careerEyebrow: "Kariera",
    careerTitle: "Dołącz do naszego zespołu",
    careerLead:
      "Kochasz pracę w opiece i chcesz pracować w serdecznym zespole, który ma prawdziwy czas dla ludzi? W takim razie czekamy na Twoje zgłoszenie.",
    applyNow: "Aplikuj teraz",
    applySubject: "Aplikacja: Pomoc pielęgnacyjna (k/m/d)",
    tasks: "Twoje zadania",
    profile: "Twój profil",
    offer: "Oferujemy",
    interested: "Zainteresowani? Prosimy o przesłanie zgłoszenia na adres",
    orCall: "lub o telefon pod numer",
    questions: "Pytania? Skontaktuj się z nami",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "Aktualności",
      title: "Witamy na naszej nowej stronie internetowej",
      excerpt:
        "Cieszymy się, że od teraz możemy przedstawić naszą służbę opieki i nasze usługi także online: przejrzyście, jasno i zawsze pod ręką.",
      body: "Naszym celem jest udostępnienie Państwu i Państwa bliskim wszystkich ważnych informacji o opiece w domu w wygodny sposób. W razie pytań mogą Państwo w każdej chwili skontaktować się z nami telefonicznie lub przez formularz kontaktowy.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "Doradztwo",
      title: "Bezpłatne doradztwo w sprawie opieki, u nas lub u Państwa w domu",
      excerpt:
        "Nie wiedzą Państwo, jaki stopień opieki jest odpowiedni? Chętnie doradzimy osobiście i bez zobowiązań we wszystkich sprawach dotyczących kasy pielęgnacyjnej i stopni opieki.",
      body: "Niemiecki system opieki jest skomplikowany. Mamy czas, spokojnie wyjaśniamy możliwości i pomagamy w składaniu wniosków o świadczenia. Wystarczy umówić się na spotkanie.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "Zespół",
      title: "Rozwijamy się i szukamy wsparcia",
      excerpt:
        "Nasz zespół stale się powiększa. Dołącz do serdecznego grona, dla którego opieka oznacza czas i szacunek.",
      body: "Oferujemy uczciwe warunki pracy, pełną szacunku atmosferę i prawdziwy czas dla osób, którymi się opiekujemy. Zapraszamy do zapoznania się z naszymi aktualnymi ofertami pracy.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "Pomoc pielęgnacyjna (k/m/d)",
      type: "Niepełny lub pełny etat",
      location: "Frankfurt nad Menem, Nieder-Eschbach",
      intro:
        "Aby wzmocnić nasz zespół, szukamy pomocy pielęgnacyjnej, która wypełni życiem nasze wartości: czas, szacunek i troskę. Mile widziane są także osoby zmieniające zawód, które mają serce do tej pracy.",
      tasks: [
        "Wsparcie w pielęgnacji podstawowej naszych podopiecznych",
        "Pomoc w poruszaniu się i w codziennych czynnościach",
        "Towarzyszenie i ludzka bliskość",
        "Ścisła współpraca w zespole opiekuńczym",
      ],
      requirements: [
        "Radość z pracy z ludźmi i empatia",
        "Niezawodność, poczucie odpowiedzialności i duch zespołowy",
        "Pierwsze doświadczenie w opiece mile widziane (nie jest wymagane)",
        "Prawo jazdy kategorii B mile widziane",
      ],
      offer: [
        "Uczciwe, terminowe wynagrodzenie",
        "Pełen szacunku, serdeczny zespół",
        "Prawdziwy czas na opiekę, bez pośpiechu",
        "Wdrożenie oraz szkolenia i doskonalenie zawodowe",
      ],
    },
  ],

  contact: {
    eyebrow: "Kontakt",
    title: "Jesteśmy dla Państwa",
    subtitle:
      "Pytania o opiekę, prośba o termin czy konsultacja: prosimy o kontakt bez zobowiązań. Czekamy na Państwa.",
    formTitle: "Napisz do nas",
    formLead: "Odpowiemy tak szybko, jak to możliwe.",
    name: "Imię i nazwisko",
    namePlaceholder: "Państwa imię i nazwisko",
    email: "E-mail",
    emailPlaceholder: "imie@przyklad.de",
    phone: "Telefon",
    phonePlaceholder: "Państwa numer telefonu",
    message: "Wiadomość",
    messagePlaceholder: "Jak możemy pomóc?",
    consentBefore: "Zapoznałem/-am się z",
    consentLink: "polityką prywatności",
    consentAfter:
      "i wyrażam zgodę na przetwarzanie moich danych (w tym ewentualnych informacji o stanie zdrowia zawartych w wiadomości) w celu rozpatrzenia mojego zapytania. Zgodę mogę wycofać w każdej chwili.",
    submit: "Wyślij wiadomość",
    sending: "Wysyłanie…",
    subject: "Zapytanie przez stronę internetową",
    errName: "Prosimy o podanie imienia i nazwiska.",
    errEmail: "Prosimy o podanie prawidłowego adresu e-mail.",
    errMessage: "Prosimy o napisanie krótkiej wiadomości.",
    errConsent: "Prosimy o zaakceptowanie polityki prywatności.",
    toastCheck: "Prosimy o sprawdzenie wprowadzonych danych.",
    toastSuccess: "Dziękujemy! Wiadomość została wysłana.",
    toastError: "Wystąpił błąd. Prosimy o telefon.",
    successTitle: "Dziękujemy!",
    successText: "Wiadomość została przekazana. Wkrótce się z Państwem skontaktujemy.",
    sendAnother: "Wyślij kolejną wiadomość",
    reachTitle: "Jak nas zastać",
    address: "Adres",
    phoneLabel: "Telefon",
    fax: "Faks",
    emergency: "Całodobowy numer alarmowy",
    alternatively: "alternatywnie",
    emailLabel: "E-mail",
    hoursTitle: "Godziny pracy biura",
    hours: "Od poniedziałku do piątku: od 08:00 do 17:00",
    careAndEmergency: "Opieka i numer alarmowy:",
    aroundTheClock: "całą dobę",
    mapTitle: "Jak do nas trafić",
    mapIframeTitle: "Lokalizacja Nieder-Eschbacher Pflegedienst w Google Maps",
    mapLoad: "Wczytaj mapę",
    mapNotice:
      "Ze względu na ochronę danych mapa Google Maps wczytuje się dopiero po Państwa zgodzie. Wówczas dane są przekazywane do Google.",
    mapButton: "Wczytaj mapę i pokaż lokalizację",
    mapAlt: "Lub otwórz w Google Maps",
  },

  reviews: {
    eyebrow: "Opinie",
    title: "Co mówią bliscy i pacjenci",
    emptyLead: "Państwa doświadczenie pomaga innym rodzinom we Frankfurcie znaleźć odpowiednią służbę opieki.",
    countOn: "opinii w",
    source: "Publiczne opinie z naszego Profilu Firmy w Google.",
    asOf: "Stan na:",
    all: "Wszystkie opinie w Google",
    write: "Napisz opinię",
    on: "w",
    starsLabel: "na 5 gwiazdek",
  },

  notFound: {
    title: "Nie znaleziono strony",
    subtitle: "Błąd 404",
    text: "Wybrana strona nie istnieje lub została przeniesiona.",
    home: "Do strony głównej",
  },

  imprint: {
    title: "Impressum",
    subtitle: "Informacje zgodnie z § 5 niemieckiej ustawy o usługach cyfrowych (DDG)",
    company: "Informacje zgodnie z § 5 DDG",
    country: "Niemcy",
    representedBy: "Reprezentowana przez",
    managingDirector: "Dyrektor zarządzająca",
    contact: "Kontakt",
    phone: "Telefon",
    fax: "Faks",
    email: "E-mail",
    register: "Wpis do rejestru",
    registerCourt: "Sąd rejestrowy",
    registerNumber: "Numer rejestru",
    taxNumber: "Numer podatkowy",
    licence: "Zezwolenie i organ nadzoru",
    licenceText:
      "Dopuszczona ambulatoryjna służba opieki na podstawie umowy o świadczenie usług zgodnie z § 72 Kodeksu socjalnego, księga XI (SGB XI), zawartej z krajowymi związkami kas pielęgnacyjnych w Hesji.",
    authorityText:
      "Właściwy organ nadzoru zgodnie z heską ustawą o usługach opiekuńczych i pielęgnacyjnych (HGBP):",
    dispute: "Rozstrzyganie sporów konsumenckich",
    disputeText:
      "Nie jesteśmy gotowi ani zobowiązani do udziału w postępowaniu w sprawie rozstrzygania sporów przed konsumenckim organem polubownym (§ 36 VSBG).",
    responsible: "Odpowiedzialna za treść zgodnie z § 18 ust. 2 Umowy państwowej o mediach (MStV)",
    credit: "Koncepcja i realizacja techniczna",
    liabilityContent: "Odpowiedzialność za treści",
    liabilityContentText:
      "Jako usługodawca odpowiadamy za własne treści na tych stronach zgodnie z ogólnie obowiązującymi przepisami. Nie jesteśmy jednak zobowiązani do monitorowania przekazywanych lub przechowywanych informacji obcych ani do badania okoliczności wskazujących na działalność niezgodną z prawem (art. 8 rozporządzenia (UE) 2022/2065, akt o usługach cyfrowych). Obowiązki usunięcia lub zablokowania wykorzystania informacji wynikające z ogólnie obowiązujących przepisów pozostają nienaruszone. Odpowiedzialność w tym zakresie jest możliwa dopiero od chwili powzięcia wiadomości o konkretnym naruszeniu prawa. Po powzięciu wiadomości o takich naruszeniach niezwłocznie usuniemy te treści.",
    liabilityLinks: "Odpowiedzialność za linki",
    liabilityLinksText:
      "Nasza strona zawiera linki do zewnętrznych stron osób trzecich, na których treść nie mamy wpływu. Dlatego nie możemy ponosić odpowiedzialności za te obce treści. Za treść stron, do których prowadzą linki, odpowiada zawsze ich dostawca lub operator. Strony te zostały sprawdzone pod kątem ewentualnych naruszeń prawa w chwili umieszczenia linku; niezgodne z prawem treści nie były wówczas rozpoznawalne. Stała kontrola treści stron, do których prowadzą linki, bez konkretnych przesłanek naruszenia prawa nie jest możliwa. Po powzięciu wiadomości o naruszeniach prawa niezwłocznie usuniemy takie linki.",
    copyright: "Prawa autorskie",
    copyrightText:
      "Treści i utwory stworzone przez operatora strony podlegają niemieckiemu prawu autorskiemu. Powielanie, opracowywanie, rozpowszechnianie i wszelkie wykorzystanie poza granicami prawa autorskiego wymagają pisemnej zgody danego autora lub twórcy. Pobieranie i kopiowanie tej strony jest dozwolone wyłącznie do użytku prywatnego, niekomercyjnego. O ile treści na tej stronie nie zostały stworzone przez operatora, respektowane są prawa autorskie osób trzecich; w szczególności treści osób trzecich są oznaczane jako takie. Jeśli mimo to zauważą Państwo naruszenie praw autorskich, prosimy o stosowną informację. Po powzięciu wiadomości o naruszeniach niezwłocznie usuniemy takie treści.",
  },

  privacy: {
    title: "Polityka prywatności",
    subtitle: "Informacje o przetwarzaniu Państwa danych osobowych zgodnie z RODO",
    retention: "sześciu miesięcy",
    lastUpdated: "Stan na: październik 2026",
    controller: {
      title: "1. Administrator",
      lead: "Administratorem danych przetwarzanych na tej stronie w rozumieniu ogólnego rozporządzenia o ochronie danych (RODO) jest:",
      representedBy: "reprezentowana przez dyrektor zarządzającą",
      phone: "Telefon",
      fax: "Faks",
      email: "E-mail",
    },
    dpo: {
      title: "Inspektor ochrony danych",
      lead: "Z naszym inspektorem ochrony danych można się skontaktować pod adresem:",
    },
    general: {
      title: "2. Informacje ogólne o przetwarzaniu danych",
      p: [
        "Przetwarzamy dane osobowe tylko w zakresie niezbędnym do zapewnienia działającej strony internetowej oraz do rozpatrywania Państwa zapytań. Podstawą prawną są art. 6 ust. 1 lit. a RODO (zgoda), art. 6 ust. 1 lit. b RODO (umowa lub działania przed zawarciem umowy) oraz art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes polegający na bezpiecznym i stabilnym działaniu tej strony).",
        "Ta strona **nie używa plików cookie**, nie zapisuje informacji na Państwa urządzeniu (§ 25 TDDDG) i nie korzysta z usług analitycznych, śledzących ani reklamowych. Czcionki i obrazy są dostarczane z naszego własnego serwera; podczas otwierania stron żadne dane nie są przekazywane do zewnętrznych usług czcionek ani obrazów. Nie ma miejsca zautomatyzowane podejmowanie decyzji, w tym profilowanie (art. 22 RODO).",
      ],
    },
    hosting: {
      title: "3. Hosting i pliki dziennika serwera",
      ownIntro:
        "Ta strona jest prowadzona na nasze zlecenie przez {operator} na serwerze w Niemczech. Dostawcą centrum danych i serwera jest {provider}.",
      logs: "Przy każdym wejściu przetwarzane są technicznie niezbędne dane połączenia: adres IP, data i godzina dostępu, wywołana strona, ilość przesłanych danych, typ i wersja przeglądarki, system operacyjny oraz poprzednio odwiedzona strona (referrer). Dane te nie są łączone z innymi źródłami danych i służą wyłącznie dostarczaniu strony, jej bezpieczeństwu i analizie błędów. Podstawą prawną jest art. 6 ust. 1 lit. f RODO. Pliki dziennika serwera są przechowywane tylko tak długo, jak wymaga tego bezpieczne działanie, a następnie usuwane lub anonimizowane.",
      ownLegal:
        "Z operatorem i dostawcą centrum danych zawarto umowy powierzenia przetwarzania danych zgodnie z art. 28 RODO. W ramach hostingu nie następuje przekazywanie do państw trzecich.",
    },
    form: {
      title: "4. Formularz kontaktowy",
      p: [
        "Jeśli wyślą Państwo zapytanie przez formularz kontaktowy, przetwarzamy wprowadzone dane (imię i nazwisko, adres e-mail, opcjonalnie numer telefonu oraz wiadomość) w celu rozpatrzenia zapytania i ewentualnych pytań uzupełniających. Podstawą prawną jest art. 6 ust. 1 lit. b RODO (nawiązanie stosunku opieki) oraz, jeżeli przekazują nam Państwo informacje o stanie zdrowia, Państwa wyraźna zgoda zgodnie z art. 9 ust. 2 lit. a RODO, wyrażana przez zaznaczenie pola w formularzu.",
        "Polami obowiązkowymi są imię i nazwisko, adres e-mail oraz wiadomość; numer telefonu jest dobrowolny. Bez danych obowiązkowych nie możemy rozpatrzyć zapytania; w takim przypadku zawsze mogą Państwo do nas zadzwonić. Przesyłanie odbywa się w sposób zaszyfrowany (TLS). Zapytanie jest przechowywane wyłącznie na serwerze w Niemczech działającym na nasze zlecenie i nie jest przekazywane osobom trzecim. Dane usuwamy najpóźniej po upływie {retention} od zakończenia rozpatrywania zapytania, o ile nie dojdzie do nawiązania stosunku opieki i nie sprzeciwiają się temu ustawowe obowiązki przechowywania. Zgodę mogą Państwo w każdej chwili wycofać ze skutkiem na przyszłość, np. e-mailem na adres {email}.",
      ],
    },
    emailPhone: {
      title: "5. Kontakt przez e-mail, telefon lub WhatsApp",
      p: [
        "Jeśli kontaktują się Państwo z nami przez e-mail lub telefonicznie, przetwarzamy Państwa dane w celu załatwienia sprawy (art. 6 ust. 1 lit. b i f RODO). Prosimy pamiętać, że niezaszyfrowane wiadomości e-mail mogą zostać odczytane przez osoby trzecie w trakcie przesyłania; w przypadku informacji o stanie zdrowia zalecamy telefon lub rozmowę osobistą.",
        "Wiadomości na adres {email} docierają do nas przez usługę przekierowania: doręczenie zapewnia {forwarder}, a skrzynka znajduje się u {mailbox}. Przetwarzane są przy tym adres nadawcy, temat i treść wiadomości, a dane są przekazywane również do USA. Podstawą prawną jest art. 6 ust. 1 lit. f RODO. Dlatego prosimy nie przesyłać danych o zdrowiu pocztą elektroniczną i korzystać w tym celu z telefonu lub rozmowy osobistej.",
        "Na naszej stronie znajduje się link, przez który mogą Państwo napisać do nas na WhatsAppie. Dostawcą jest WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irlandia. Link jest zwykłym odesłaniem: dopiero po jego kliknięciu nawiązywane jest połączenie z WhatsAppem, a Państwa numer telefonu komórkowego oraz treść wiadomości są przekazywane do WhatsAppa. Podstawą prawną jest art. 6 ust. 1 lit. b RODO. WhatsApp przetwarza dane także poza UE; Meta posiada certyfikat w ramach EU-US Data Privacy Framework. Prosimy nie przesyłać przez WhatsApp danych o zdrowiu, a w nagłych przypadkach korzystać z telefonu.",
      ],
    },
    applications: {
      title: "6. Aplikacje o pracę",
      p: [
        "Zgłoszenia na nasze oferty pracy przesyłają Państwo e-mailem. Dokumenty aplikacyjne przetwarzamy wyłącznie w celu przeprowadzenia procesu rekrutacji (art. 6 ust. 1 lit. b RODO, § 26 BDSG). Po zakończeniu procesu dokumenty są usuwane najpóźniej po sześciu miesiącach, chyba że wyrazili Państwo zgodę na dłuższe przechowywanie lub dojdzie do nawiązania stosunku pracy.",
      ],
    },
    maps: {
      title: "7. Google Maps (rozwiązanie dwóch kliknięć)",
      p: [
        "Na stronie kontaktowej udostępniamy mapę usługi Google Maps. Dostawcą jest Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irlandia. Mapa wczytuje się **dopiero po Państwa wyraźnym kliknięciu** przycisku „Wczytaj mapę”; wcześniej żadne dane nie są przekazywane do Google. Klikając, wyrażają Państwo zgodę (art. 6 ust. 1 lit. a RODO) na przetwarzanie przez Google Państwa adresu IP i danych o korzystaniu oraz ewentualne przekazanie ich na serwery Google LLC w USA; Google może przy tym zapisać pliki cookie na Państwa urządzeniu. Google posiada certyfikat w ramach EU-US Data Privacy Framework i dodatkowo stosuje standardowe klauzule umowne. Zgoda obowiązuje tylko dla bieżącego wyświetlenia strony. Więcej informacji: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. Państwa prawa",
      lead: "W odniesieniu do swoich danych osobowych przysługują Państwu wobec nas następujące prawa:",
      items: [
        "Prawo dostępu (art. 15 RODO)",
        "Prawo do sprostowania (art. 16 RODO)",
        "Prawo do usunięcia (art. 17 RODO)",
        "Prawo do ograniczenia przetwarzania (art. 18 RODO)",
        "Prawo do przenoszenia danych (art. 20 RODO)",
        "Prawo do sprzeciwu wobec przetwarzania na podstawie art. 6 ust. 1 lit. f RODO (art. 21 RODO)",
        "Prawo do wycofania udzielonej zgody ze skutkiem na przyszłość (art. 7 ust. 3 RODO)",
      ],
      how: "Aby skorzystać ze swoich praw, wystarczy nieformalna wiadomość na adres {email} lub pocztą na podany wyżej adres.",
    },
    authority: {
      title: "9. Prawo do wniesienia skargi do organu nadzorczego",
      lead: "Mają Państwo prawo wnieść skargę do organu nadzorczego ds. ochrony danych (art. 77 RODO). Organem właściwym dla nas jest:",
      name: "Heski Pełnomocnik ds. Ochrony Danych i Wolności Informacji",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden, Niemcy",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. Bezpieczeństwo danych",
      p: [
        "Ta strona jest dostarczana wyłącznie przez szyfrowane połączenie HTTPS (TLS). Stosujemy środki techniczne i organizacyjne, aby chronić Państwa dane przed utratą, manipulacją i nieuprawnionym dostępem, i na bieżąco dostosowujemy je do aktualnego stanu techniki.",
      ],
    },
    changes: {
      title: "11. Zmiany niniejszej polityki prywatności",
      p: [
        "Aktualizujemy niniejszą politykę prywatności, gdy zmienia się stan prawny lub nasza strona internetowa. Obowiązuje wersja opublikowana w tym miejscu.",
      ],
    },
  },
};

export default pl;
